import { render } from "./LoadingPage.vue?vue&type=template&id=2f86417c&scoped=true"
import script from "./LoadingPage.vue?vue&type=script&lang=js"
export * from "./LoadingPage.vue?vue&type=script&lang=js"

import "./LoadingPage.vue?vue&type=style&index=0&id=2f86417c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f86417c"]])

export default __exports__